export const APP_NAME = "FearGreed";
export const SUPPORT_EMAIL = "support@feargreed.app";
export const DOMAIN = "https://feargreed.app";
export const DATA_SOURCE = "alternative.me";
export const DATA_SOURCE_URL = "https://alternative.me/crypto/fear-and-greed-index/";

/** Internal base URL for runtime fetches (badge <img>, etc.) — NOT for public docs */
export const API_BASE = `https://${import.meta.env.VITE_SUPABASE_PROJECT_ID ?? "ylhnppwynzlczlfikktf"}.supabase.co/functions/v1`;

/** Public-facing API base URL for documentation, copy buttons, curl examples */
export const API_PUBLIC_BASE = `https://api.feargreed.app`;

/** Maps public endpoint paths to internal function names */
export const PUBLIC_ENDPOINTS = {
  latest:     { public: "/fng/latest",        internal: "/fng-latest",  label: "GET Latest",          format: "JSON" },
  history:    { public: "/fng/history",       internal: "/fng-history", label: "GET History",          format: "JSON" },
  summary:    { public: "/fng/summary.txt",   internal: "/fng-summary", label: "GET Summary",          format: "text/plain" },
  context:    { public: "/fng/context.json",  internal: "/fng-context", label: "GET Context",          format: "JSON" },
  pulse:      { public: "/fng/pulse.json",    internal: "/fng-pulse",   label: "GET Pulse",            format: "JSON" },
  badge:      { public: "/fng/badge.svg",     internal: "/fng-badge",   label: "GET Badge (SVG)",      format: "SVG" },
  tape:       { public: "/market-tape.json",  internal: "/fng-tape",    label: "GET Market Tape",      format: "JSON" },
} as const;
